"use strict";exports.__esModule = true;exports.symbol = symbol;function symbol() {
  // eslint-disable-next-line max-len,quotes
  return '<symbol viewbox="0 0 24 24" id=icon-carousel-prev><path d="m6.293 11.292 8-8a1 1 0 1 1 1.414 1.415L8.414 12l7.293 7.293a1 1 0 1 1-1.414 1.414l-8-8a.996.996 0 0 1 0-1.415Z"></path></symbol>';
}